import { Fragment } from "react";
import { View } from "react-native";
import { Link } from "solito/link";
import { NAV_BAR_LOGO_SIZE } from "src/components/NavBar/constants";
import PillButton from "src/components/PillButton";
import IconLogo from "src/icons/IconLogo";
import { paddingMedium } from "src/styles/spacing";
import { BasicModularNavBarTemplateItem, BasicModularNavBarTemplateProps } from "./types";

const renderItemGroup = (
	item: BasicModularNavBarTemplateItem[] | BasicModularNavBarTemplateItem,
	index: number,
) => {
	if (Array.isArray(item)) {
		return (
			<View
				pointerEvents="box-none"
				key={`group-${index}`}
				style={{
					flexDirection: "row",
					columnGap: paddingMedium,
					alignItems: "center",
				}}
			>
				{item.map(renderItemGroup)}
			</View>
		);
	}
	if (typeof item === "function") {
		return <Fragment key={`fn-${index}`}>{item()}</Fragment>;
	}
	if (item == null || item == false) {
		return null;
	}

	return (
		<PillButton
			onPress={item.onPress}
			testID={item.testID}
			key={`item-${index}-${item.testID}-${item.text}`}
			Icon={item.Icon}
			loading={item.loading}
			textProps={{
				semibold: item.important,
			}}
			opaque
		>
			{item.text}
		</PillButton>
	);
};

const BasicModularNavBarTemplate = ({ items, includeLogo }: BasicModularNavBarTemplateProps) => {
	return (
		<>
			{includeLogo && (
				<View
					pointerEvents="box-none"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						justifyContent: "center",
						alignItems: "center",
						marginLeft: "auto",
						marginRight: "auto",
					}}
				>
					<Link href="/home">
						<IconLogo size={NAV_BAR_LOGO_SIZE} />
					</Link>
				</View>
			)}
			{items.length === 1 && <View />}
			{items.map(renderItemGroup)}
		</>
	);
};
export default BasicModularNavBarTemplate;
